import type {
  TaskAssignmentResponse,
  TaskAssignmentStateEnum,
} from 'src/api/ProactApiClient';

export enum TaskActiveView {
  Complete = 0,
  Incomplete = 1,
  ReadyForReview = 2,
}

export interface TaskModalData {
  Completed: AssigneeData[];
  Assigned: AssigneeData[];
}

export interface TaskRawModalData {
  id: number;
  label: string;
  state: TaskAssignmentStateEnum;
  taskAssignmentState: string;
  notes?: string;
}

export interface TaskSelectedData {
  id: number;
  key: string;
}

export interface getFormMetaProps {
  mode: any;
  meta: any;
  personItems: any;
  isChild: boolean;
}

export interface AssigneeData extends TaskAssignmentResponse {
  taskAssignmentState: string;
}

export interface AssignTo {
  entityType: number;
  id: number;
  label: string;
  selectedOptionKey: number;
}

export interface TaskSelectOptions {
  standards?: SelectOptions_Standard[];
  formDefinitionList?: SelectOptions_FormDefinition[];
}

export interface SelectOptions_Standard {
  id: number;
  label: string;
}

export interface SelectOptions_FormDefinition {
  id: number;
  text: string;
}
